// Copyright (c) 2022 by Move Closer

import { ComponentObjectPropsOptions, Emit } from '../../vue-api'

import { ModalInnerProps, UseModalInnerContentProvides } from './ModalInner.contracts'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const modalInnerProps: ComponentObjectPropsOptions<ModalInnerProps> = {

  /**
   * @see ModalInnerProps.noPadding
   */
  noPadding: {
    type: Boolean,
    required: false,
    default: false
  },

  /**
   * @see showCloseToggle
   */
  showCloseToggle: {
    type: Boolean,
    required: false,
    default: true
  }
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const useModalInner = (props: ModalInnerProps, emit: Emit): UseModalInnerContentProvides => {
  const onClose = (): void => {
    emit('close')
  }

  return { onClose }
}
